import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthserviceService {

  constructor(private http: HttpClient) { }

  onlogin(obj: any) {
    const headers = {
      "Authorization": 'Basic c2NlbXBsb3llZTpzZWNyZXQ=',
      "Content-Type": ' application/json'
    }
    return this.http.post(environment.apiUrl + '/security/oauth/authenticate', obj, { headers: headers },);
  }
  removetoken() {
    localStorage.removeItem('token');
  }
 

}




